'use client';

import { useEffect } from 'react';
import { useSession } from "@/lib/auth/client";
import { trackSignup } from '@/lib/gtag';
import { trackMetaCompleteRegistration } from '@/lib/meta-pixel';

const SIGNUP_TRACKED_KEY_PREFIX = 'linkai_signup_tracked_';

type SignupSessionUser = {
  id: string;
  isNewSignup?: boolean;
  signupMethod?: string;
};

export function SignupConversionTracker() {
  const { data: session, status } = useSession();

  useEffect(() => {
    const user = session?.user as SignupSessionUser | undefined;

    if (status !== 'authenticated' || !user?.id || !user.isNewSignup) {
      return;
    }

    const userId = user.id;
    const storageKey = `${SIGNUP_TRACKED_KEY_PREFIX}${userId}`;

    try {
      if (typeof window !== 'undefined' && localStorage.getItem(storageKey)) {
        return;
      }
    } catch {
      return;
    }

    const method = user.signupMethod ?? 'email';
    trackSignup({ method });
    trackMetaCompleteRegistration();

    try {
      localStorage.setItem(storageKey, '1');
    } catch {
      // Ignore storage failures; conversion already sent.
    }
  }, [status, session?.user]);

  return null;
}
